export default __webpack_public_path__ + "static/ir-c8fef69f398c93bc01566fa3fc0f3ca1.wav";